module.exports = __webpack_public_path__ + "static/front/img/ship_icon_1.f842f502.png";